const sacraments = [
    {
      id: 1,
      name: 'Baptism',
      href: '/baptism',
      imageSrc: '/pictures/IMG_5331.JPG',
      imageAlt: "Baptism",
    },
    {
      id: 2,
      name: 'First Holy Communion and Confirmation',
      href: '/first-holy-communion',
      imageSrc: '/pictures/IMG_5226.JPG',
      imageAlt: "First Holy Communion",
    },
    {
      id: 3,
      name: 'Holy Communion at Home',
      href: '/holy-communion-at-home',
      imageSrc: '/pictures/Offering.jpg',
      imageAlt: "Holy Communion at Home",
    },
    // {
    //   id: 5,
    //   name: 'Marriage',
    //   href: '/marriage',
    //   imageSrc: '',
    //   imageAlt: "Marriage",
    // },
    // {
    //   id: 6,
    //   name: 'Rite of Christian Initiation of Adults',
    //   href: '/rcia',
    //   imageSrc: '',
    //   imageAlt: "Rite of Christian Initiation of Adults",
    // },
    // {
    //   id: 7,
    //   name: 'Sacrament of the sick',
    //   href: '/sacrament-of-sick',
    //   imageSrc: '',
    //   imageAlt: "Sacrament of the sick",
    // },
  ]

export default function SacramentsPage() {
    return (
          <div className="min-h-screen container mx-auto px-4">
            <h1 className="text-3xl font-bold text-center my-6">Sacraments</h1>
  
            <div className="mb-16 flex flex-col items-center space-y-6 sm:flex-row sm:justify-center sm:space-y-0 sm:space-x-12">
              {sacraments.map((sacrament) => (
                <a
                  key={sacrament.id}
                  href={sacrament.href}
                  className="relative w-60 h-60 rounded-md overflow-hidden group shadow-lg block"
                >
                  {/* Image */}
                  <img
                    src={sacrament.imageSrc}
                    alt={sacrament.imageAlt}
                    className="w-full h-full object-cover transition-opacity duration-300 group-hover:opacity-75"
                  />

                  {/* Overlay */}
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="text-white text-lg font-semibold">
                      {sacrament.name || "View"}
                    </span>
                  </div>

                  {/* Title overlayed at the bottom of the card */}
                  <div className="absolute bottom-0 left-0 w-full bg-white/80 py-2 text-center">
                    <h3 className="text-sm font-medium text-gray-800">{sacrament.name}</h3>
                  </div>
                </a>
              ))}
            </div>
        </div>
        )
  }